import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";

export class LinkShareWidget extends Widget {
	componentWillMount() {
		this.state.sharelink = null;
		this.state.open = false;

		this.toggle = this.toggle.bind(this);

		this.copyLink = this.copyLink.bind(this);
		this.facebook = this.facebook.bind(this);
		this.twitter = this.twitter.bind(this);
		this.bluesky = this.bluesky.bind(this);
		this.email = this.email.bind(this);
		this.reddit = this.reddit.bind(this);
	}

	componentDidMount() {
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has("share") && searchParams.get("share") === "open")
			this.toggle();

		// document.addEventListener("click", this.handleOutsideClick);
	}

	componentWillUnmount() {
		// Remove event listener when component unmounts
		// document.removeEventListener("click", this.handleOutsideClick);
	}

	toggle(e = null) {
		console.log("toggle");
		this.setState(
			{
				open: !this.state.open,
			},
			() => {
				this.fetchSharelink();
			}
		);
	}

	handleOutsideClick = (event) => {
		// Get reference to the LinkShare component
		const linkShareElement = document.querySelector(".LinkShare");
		const linkShareBoxElement = document.querySelector(".LinkShare__Box");

		// If click is outside the widget and widget is open, close it
		if (
			this.state.open &&
			linkShareElement &&
			linkShareBoxElement &&
			!linkShareElement.contains(event.target) &&
			!linkShareBoxElement.contains(event.target)
		) {
			this.toggle();
		}
	};

	linkFor(token) {
		return `${this.props.permalink}/sharetoken/${token}`;
	}

	fetchSharelink() {
		if (this.state.sharelink) return;

		const self = this;

		//if post not paywalled, or if the current user isnt a member just use permalink
		if (!this.props.paywall || !this.props.member) {
			this.setState({ sharelink: this.props.permalink });
			return;
		}

		//read client-cached token, use that instead of making request
		const token = localStorage.getItem(`sharelink_${this.props.permalink}`);
		if (token) {
			self.setState({
				sharelink: this.linkFor(token),
			});
			return;
		}

		return fetch(
			`https://accounts.${document.location.hostname}/doesspress/share-token?shareid=${this.props.shareid}`,
			{
				method: "PUT",
				credentials: "include",
			}
		)
			.then((response) => {
				return response.json();
			})
			.then((response) => {
				localStorage.setItem(
					`sharelink_${this.props.permalink}`,
					response.token
				);
				self.setState({
					sharelink: this.linkFor(response.token),
				});
			})
			.catch((error) => {
				console.log("share token error", error);
				self.setState({
					sharelink: `${this.props.permalink}`,
				});
			});
	}

	twitter() {
		window.open(
			`https://twitter.com/intent/tweet?via=TPM&text=${encodeURIComponent(
				this.props.title
			)}&url=${this.state.sharelink}`,
			"newwindow",
			"width=530, height=450"
		);
	}

	bluesky() {
		window.open(
			`https://bsky.app/intent/compose?text=${encodeURIComponent(
				this.props.title
			)}%20${this.state.sharelink}`,
			"newwindow",
			"width=530, height=450"
		);
	}

	facebook() {
		window.open(
			`https://www.facebook.com/sharer/sharer.php?u=${
				this.state.sharelink
			}&t=${encodeURIComponent(this.props.title)}`,
			"newwindow",
			"width=530, height=450"
		);
	}

	reddit() {
		window.open(
			`https://www.reddit.com/submit?url=${
				this.state.sharelink
			}&title=${encodeURIComponent(this.props.title)}`,
			"newwindow",
			"width=530, height=600"
		);
	}

	email() {
		window.open(
			`mailto:?subject=${this.props.title}&body=I%20am%20giving%20you%20free%20access%20to%20this%20members-only%20article%20on%20TPM:%20${this.state.sharelink}`,
			"newwindow"
		);
	}

	copyLink() {
		this.copy(this.state.sharelink);
	}

	copy(text) {
		navigator.clipboard.writeText(text).then(
			function () {
				/* success */
				$(".js_linkshare-copied").addClass("--visible");

				setTimeout(() => {
					$(".js_linkshare-copied").removeClass("--visible");
				}, 4000);
			},
			function () {
				/* failure */
			}
		);
	}

	renderSpinner() {
		return (
			<div>
				<Icon name="spinner-third" style="regular" />
				<p>
					<i>Generating Link</i>
				</p>
			</div>
		);
	}

	renderShareables() {
		return [
			<a class="LinkShare__Social" onClick={this.copyLink}>
				<span class="icon">
					<Icon name="link" style="regular" />
				</span>
				Copy Link
				<div class="LinkShare__Copied js_linkshare-copied">
					<span class="icon">
						<Icon name="check" style="regular" />
					</span>
					Copied
				</div>
			</a>,

			<a class="LinkShare__Social" onClick={this.email}>
				<span class="icon">
					<Icon name="envelope" style="regular" />
				</span>
				Email
			</a>,

			<a class="LinkShare__Social" onClick={this.bluesky}>
				<span class="icon">
					<Icon name="bluesky" style="brands" />
				</span>
				Bluesky
			</a>,

			<a class="LinkShare__Social" onClick={this.facebook}>
				<span class="icon">
					<Icon name="facebook-f" style="brands" />
				</span>
				Facebook
			</a>,

			<a class="LinkShare__Social" onClick={this.twitter}>
				<span class="icon">
					<Icon name="x-twitter" style="brands" />
				</span>
				X
			</a>,

			<a class="LinkShare__Social" onClick={this.reddit}>
				<span class="icon">
					<Icon name="reddit" style="brands" />
				</span>
				Reddit
			</a>,
		];
	}

	renderContent() {
		return [
			<div class="LinkShare">
				<div class={`LinkShare__ShareButton`} onClick={this.toggle}>
					{this.props.paywall && this.props.member ? (
						<Icon name="gift" style="regular" />
					) : (
						<Icon name="arrow-up-from-bracket" style="sharp-light" />
					)}{" "}
					Share
				</div>
			</div>,
			this.state.open && (
				<div class={`LinkShare__Box`}>
					<div class="LinkShare__Top">
						<div class="LinkShare__Heading">SHARE ARTICLE</div>
						<div class="LinkShare__Close" onClick={this.toggle}>
							<Icon name="xmark" style="light" />
						</div>
					</div>
					<div className="LinkShare__Title">{this.props.title}</div>
					{this.props.member && this.props.paywall && (
						<p class="LinkShare__ExplainToMembers">
							You can share this members-only article with non-members. Anyone
							can read it using your link.
						</p>
					)}
					{this.state.sharelink
						? this.renderShareables()
						: this.renderSpinner()}
				</div>
			),
		];
	}
}
